import React from 'react'
import PropTypes from 'prop-types'
import classNames from "classnames";

export function Status({children, className, type = 'primary', size = 'large'}) {
    return <span
        className={classNames('uppercase text-white font-bold rounded-full flex items-center justify-center', {
            'bg-primary-500': type === 'primary',
            'bg-gradient-to-r from-bright-blue-500 to-bright-blue-900': type === 'secondary',
            'py-2.5 px-3.5 text-xs md:text-base': size === 'large',
            'py-1 px-1.5 text-xs': size === 'small',
        }, className)}
    >
        {children}
    </span>
}

Status.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    type: PropTypes.oneOf(['primary', 'secondary']),
    size: PropTypes.oneOf(['small', 'large'])
}
